module.exports = __webpack_public_path__ + "static/media/embed.2235d7ad.svg";